/* eslint-disable import/no-mutable-exports */
import store from '@carvana/purchase-store';
import * as Services from '../services';
import * as types from './action-types';

export const GetNotarizeStatus = () => {
  return store
    .dispatch({
      type: types.GET_NOTARIZE_STATUS,
      async payload() {
        return Services.getNotarizeStatus();
      }
    })
}
